(function () {
  'use strict';

  function initBundleSwiper(el, attempts) {
    attempts = attempts || 0;

    if (typeof Swiper === 'undefined') {
      // Swiper library abhi load nahi hui — retry karo, permanently mat ruko
      if (attempts > 50) {
        // ~5s tak try kiya, ab give up karo but content ko visible kar do
        el.classList.add('is-ready');
        return;
      }
      window.setTimeout(function () {
        initBundleSwiper(el, attempts + 1);
      }, 100);
      return;
    }

    var cardCount = el.querySelectorAll('[data-bundle-card]').length;
    // Swiper loop mode ko clean duplicate karne ke liye roughly 2x
    // largest slidesPerView jitne real slides chahiye — kam hone par
    // reload ke baad ek slide flicker/missing dikhti hai. Isliye
    // loop ko slide count ke hisaab se dynamically decide karo.
    var maxSlidesPerView = 6;
    var canLoop = cardCount >= maxSlidesPerView * 2;

    var swiper = new Swiper(el, {
      loop: canLoop,
      autoplay:false,
      navigation: {
        nextEl: el.querySelector('[data-bundle-arrow="next"]'),
        prevEl: el.querySelector('[data-bundle-arrow="prev"]')
      },
      spaceBetween: 11,
      slidesPerView: 2,
      breakpoints: {
        550: { slidesPerView: 3, spaceBetween: 15 },
        750: { slidesPerView: 4, spaceBetween: 18 },
        1000: { slidesPerView: 6, spaceBetween: 21 }
      },
      on: {
        init: function () {
          el.classList.add('is-ready');
        }
      }
    });

    // Images lazy-load hoti hain, isliye kabhi kabhi slide widths
    // measure hone ke baad image load hoti hai. Sab load hone ke
    // baad ek baar update() call karo taaki kuch shift na ho.
    window.addEventListener('load', function () {
      swiper.update();
    }, { once: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-bundle-swiper]').forEach(function (el) {
      initBundleSwiper(el);
    });
  });

  function openPrestigeCartDrawer() {
    var selectors = [
      '[data-cart-drawer-toggle]',
      'a[href="#CartDrawer"]',
      '[aria-controls="CartDrawer"]',
      '.js-drawer-open-cart',
      '#CartDrawer-toggle',
      '.Header__CartToggle',
      '.header__cart-toggle',
      '.site-header__cart',
      'a.js-cart-link',
      'header a[href="/cart"]',
      'a[href="/cart"]'
    ];

    var trigger = null;
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) {
        trigger = el;
        break;
      }
    }

    if (trigger) {
      trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
      return true;
    }

    window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
      ? window.Shopify.routes.root
      : '/') + 'cart';
    return false;
  }

  var sections = document.querySelectorAll('.complete-bundle');

  sections.forEach(function (root) {
    var track = root.querySelector('[id^="CompleteBundleTrack-"]') || root.querySelector('[data-bundle-track]');
    var barTitle = root.querySelector('[data-bundle-bar-title]');
    var addBtn = root.querySelector('[data-bundle-add-btn]');
    var maxSelect = parseInt(root.dataset.maxSelect || '2', 10);
    var discountPct = parseFloat(root.dataset.discount || '20');
    var mainVariantId = root.dataset.mainVariantId;

    if (!track) return;

    function getAllCards() {
      return Array.prototype.slice.call(root.querySelectorAll('[data-bundle-card]'));
    }

    function cardsForVariant(variantId) {
      return getAllCards().filter(function (c) { return c.dataset.variantId === variantId; });
    }

    var selectedIds = [];

    function money(cents) {
      if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
        return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
      }
      return '₹' + (cents / 100).toFixed(2);
    }

    function updateCardVisual(variantId) {
      var isSelected = selectedIds.indexOf(variantId) > -1;
      cardsForVariant(variantId).forEach(function (card) {
        card.classList.toggle('is-selected', isSelected);

        var priceOriginal = card.querySelector('[data-bundle-price]');
        var priceDiscounted = card.querySelector('[data-bundle-discounted-price]');
        var discountBadge = card.querySelector('[data-bundle-discount-badge]');
        var basePrice = parseInt(card.dataset.price, 10);

        if (isSelected) {
          var discounted = Math.round(basePrice * (1 - discountPct / 100));
          priceOriginal.classList.add('is-struck');
          priceDiscounted.hidden = false;
          priceDiscounted.textContent = money(discounted);
          if (discountBadge) {
            discountBadge.hidden = false;
            discountBadge.textContent = discountPct + '% OFF';
          }
        } else {
          priceOriginal.classList.remove('is-struck');
          priceDiscounted.hidden = true;
          priceDiscounted.textContent = '';
          if (discountBadge) {
            discountBadge.hidden = true;
            discountBadge.textContent = '';
          }
        }
      });
    }

    function updateAllVisuals() {
      var seen = {};
      getAllCards().forEach(function (card) {
        var vid = card.dataset.variantId;
        if (!seen[vid]) {
          seen[vid] = true;
          updateCardVisual(vid);
        }
      });
    }

    function updateDisabledState() {
      var atLimit = selectedIds.length >= maxSelect;
      getAllCards().forEach(function (card) {
        var isSelected = selectedIds.indexOf(card.dataset.variantId) > -1;
        card.classList.toggle('is-disabled', atLimit && !isSelected);
      });
    }

    function updateBar() {
      var remaining = maxSelect - selectedIds.length;
      if (selectedIds.length === 0) {
        barTitle.textContent = 'Pick ' + maxSelect + ' to unlock ' + discountPct + '% off';
      } else if (remaining > 0) {
        barTitle.textContent = 'Pick ' + remaining + ' more to unlock ' + discountPct + '% off';
      } else {
        barTitle.textContent = discountPct + '% off applied to your ' + maxSelect + ' selected items';
      }
      addBtn.disabled = selectedIds.length !== maxSelect;
    }

    function toggleVariant(variantId, clickedCard) {
      var idx = selectedIds.indexOf(variantId);
      if (idx > -1) {
        selectedIds.splice(idx, 1);
      } else {
        if (selectedIds.length >= maxSelect) {
          if (clickedCard) {
            clickedCard.animate(
              [
                { transform: 'translateX(0)' },
                { transform: 'translateX(-4px)' },
                { transform: 'translateX(4px)' },
                { transform: 'translateX(0)' }
              ],
              { duration: 220 }
            );
          }
          return;
        }
        selectedIds.push(variantId);
      }
      updateAllVisuals();
      updateDisabledState();
      updateBar();
    }

    root.addEventListener('click', function (e) {
      var card = e.target.closest('[data-bundle-card]');
      if (!card || !root.contains(card)) return;
      toggleVariant(card.dataset.variantId, card);
    });

    var firstCard = getAllCards()[0];
    if (firstCard) {
      selectedIds = [firstCard.dataset.variantId];
    }
    updateAllVisuals();
    updateDisabledState();
    updateBar();

    addBtn.addEventListener('click', function () {
      if (selectedIds.length !== maxSelect || addBtn.disabled) return;

      addBtn.disabled = true;
      var originalLabel = addBtn.textContent;
      addBtn.textContent = 'Adding…';

      var bundleId = 'bundle-' + Date.now();
      var items = [];

      if (mainVariantId) {
        items.push({
          id: parseInt(mainVariantId, 10),
          quantity: 1
        });
      }

      selectedIds.forEach(function (variantId) {
        var refCard = cardsForVariant(variantId)[0];
        if (!refCard) return;

        var accOriginal   = parseInt(refCard.dataset.price, 10);
        var discountAmt   = Math.round((accOriginal * discountPct) / 100);
        var accDiscounted = accOriginal - discountAmt;

        items.push({
          id: parseInt(variantId, 10),
          quantity: 1,
          properties: {
            _bundled_item:           'true',
            _bundle_id:              bundleId,
            _original_price:         (accOriginal   / 100).toFixed(2),
            _discounted_price:       (accDiscounted / 100).toFixed(2),
            _bundle_discount_amount: (discountAmt   / 100).toFixed(2)
          }
        });
      });

      fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
        ? window.Shopify.routes.root + 'cart/add.js'
        : '/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: items })
      })
        .then(function (res) {
          if (!res.ok) throw new Error('Cart add failed');
          return res.json();
        })
        .then(function () {
          selectedIds = [];
          updateAllVisuals();
          updateDisabledState();
          updateBar();
          addBtn.textContent = originalLabel;

          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

          window.setTimeout(function () {
            openPrestigeCartDrawer();
          }, 50);
        })
        .catch(function (err) {
          console.error('Complete Your Bundle — add to cart error:', err);
          addBtn.textContent = originalLabel;
          addBtn.disabled = selectedIds.length !== maxSelect;
          alert('Something went wrong, please try again.');
        });
    });
  });
})();



// (function () {
//   'use strict';

//   function initBundleSwiper(el, attempts) {
//     attempts = attempts || 0;

//     if (typeof Swiper === 'undefined') {
//       // Swiper library abhi load nahi hui — retry karo, permanently mat ruko
//       if (attempts > 50) {
//         // ~5s tak try kiya, ab give up karo but content ko visible kar do
//         el.classList.add('is-ready');
//         return;
//       }
//       window.setTimeout(function () {
//         initBundleSwiper(el, attempts + 1);
//       }, 100);
//       return;
//     }

//     var cardCount = el.querySelectorAll('[data-bundle-card]').length;
//     // Swiper loop mode ko clean duplicate karne ke liye roughly 2x
//     // largest slidesPerView jitne real slides chahiye — kam hone par
//     // reload ke baad ek slide flicker/missing dikhti hai. Isliye
//     // loop ko slide count ke hisaab se dynamically decide karo.
//     var maxSlidesPerView = 6;
//     var canLoop = cardCount >= maxSlidesPerView * 2;

//     var swiper = new Swiper(el, {
//       loop: canLoop,
//       autoplay:false,
//       navigation: {
//         nextEl: el.querySelector('[data-bundle-arrow="next"]'),
//         prevEl: el.querySelector('[data-bundle-arrow="prev"]')
//       },
//       spaceBetween: 11,
//       slidesPerView: 2,
//       breakpoints: {
//         550: { slidesPerView: 3, spaceBetween: 15 },
//         750: { slidesPerView: 4, spaceBetween: 18 },
//         1000: { slidesPerView: 6, spaceBetween: 21 }
//       },
//       on: {
//         init: function () {
//           el.classList.add('is-ready');
//         }
//       }
//     });

//     // Images lazy-load hoti hain, isliye kabhi kabhi slide widths
//     // measure hone ke baad image load hoti hai. Sab load hone ke
//     // baad ek baar update() call karo taaki kuch shift na ho.
//     window.addEventListener('load', function () {
//       swiper.update();
//     }, { once: true });
//   }

//   document.addEventListener('DOMContentLoaded', function () {
//     document.querySelectorAll('[data-bundle-swiper]').forEach(function (el) {
//       initBundleSwiper(el);
//     });
//   });

//   function openPrestigeCartDrawer() {
//     var selectors = [
//       '[data-cart-drawer-toggle]',
//       'a[href="#CartDrawer"]',
//       '[aria-controls="CartDrawer"]',
//       '.js-drawer-open-cart',
//       '#CartDrawer-toggle',
//       '.Header__CartToggle',
//       '.header__cart-toggle',
//       '.site-header__cart',
//       'a.js-cart-link',
//       'header a[href="/cart"]',
//       'a[href="/cart"]'
//     ];

//     var trigger = null;
//     for (var i = 0; i < selectors.length; i++) {
//       var el = document.querySelector(selectors[i]);
//       if (el) {
//         trigger = el;
//         break;
//       }
//     }

//     if (trigger) {
//       trigger.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
//       return true;
//     }

//     window.location.href = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root
//       ? window.Shopify.routes.root
//       : '/') + 'cart';
//     return false;
//   }

//   var sections = document.querySelectorAll('.complete-bundle');

//   sections.forEach(function (root) {
//     var track = root.querySelector('[id^="CompleteBundleTrack-"]') || root.querySelector('[data-bundle-track]');
//     var barTitle = root.querySelector('[data-bundle-bar-title]');
//     var addBtn = root.querySelector('[data-bundle-add-btn]');
//     var maxSelect = parseInt(root.dataset.maxSelect || '2', 10);
//     var discountPct = parseFloat(root.dataset.discount || '20');
//     var mainVariantId = root.dataset.mainVariantId;

//     if (!track) return;

//     function getAllCards() {
//       return Array.prototype.slice.call(root.querySelectorAll('[data-bundle-card]'));
//     }

//     function cardsForVariant(variantId) {
//       return getAllCards().filter(function (c) { return c.dataset.variantId === variantId; });
//     }

//     var selectedIds = [];

//     function money(cents) {
//       if (window.Shopify && typeof window.Shopify.formatMoney === 'function' && window.theme && window.theme.moneyFormat) {
//         return window.Shopify.formatMoney(cents, window.theme.moneyFormat);
//       }
//       return '₹' + (cents / 100).toFixed(2);
//     }

//     function updateCardVisual(variantId) {
//       var isSelected = selectedIds.indexOf(variantId) > -1;
//       cardsForVariant(variantId).forEach(function (card) {
//         card.classList.toggle('is-selected', isSelected);

//         var priceOriginal = card.querySelector('[data-bundle-price]');
//         var priceDiscounted = card.querySelector('[data-bundle-discounted-price]');
//         var basePrice = parseInt(card.dataset.price, 10);

//         if (isSelected) {
//           var discounted = Math.round(basePrice * (1 - discountPct / 100));
//           priceOriginal.classList.add('is-struck');
//           priceDiscounted.hidden = false;
//           priceDiscounted.textContent = money(discounted);
//         } else {
//           priceOriginal.classList.remove('is-struck');
//           priceDiscounted.hidden = true;
//           priceDiscounted.textContent = '';
//         }
//       });
//     }

//     function updateAllVisuals() {
//       var seen = {};
//       getAllCards().forEach(function (card) {
//         var vid = card.dataset.variantId;
//         if (!seen[vid]) {
//           seen[vid] = true;
//           updateCardVisual(vid);
//         }
//       });
//     }

//     function updateDisabledState() {
//       var atLimit = selectedIds.length >= maxSelect;
//       getAllCards().forEach(function (card) {
//         var isSelected = selectedIds.indexOf(card.dataset.variantId) > -1;
//         card.classList.toggle('is-disabled', atLimit && !isSelected);
//       });
//     }

//     function updateBar() {
//       var remaining = maxSelect - selectedIds.length;
//       if (selectedIds.length === 0) {
//         barTitle.textContent = 'Pick ' + maxSelect + ' to unlock ' + discountPct + '% off';
//       } else if (remaining > 0) {
//         barTitle.textContent = 'Pick ' + remaining + ' more to unlock ' + discountPct + '% off';
//       } else {
//         barTitle.textContent = discountPct + '% off applied to your ' + maxSelect + ' selected items';
//       }
//       addBtn.disabled = selectedIds.length !== maxSelect;
//     }

//     function toggleVariant(variantId, clickedCard) {
//       var idx = selectedIds.indexOf(variantId);
//       if (idx > -1) {
//         selectedIds.splice(idx, 1);
//       } else {
//         if (selectedIds.length >= maxSelect) {
//           if (clickedCard) {
//             clickedCard.animate(
//               [
//                 { transform: 'translateX(0)' },
//                 { transform: 'translateX(-4px)' },
//                 { transform: 'translateX(4px)' },
//                 { transform: 'translateX(0)' }
//               ],
//               { duration: 220 }
//             );
//           }
//           return;
//         }
//         selectedIds.push(variantId);
//       }
//       updateAllVisuals();
//       updateDisabledState();
//       updateBar();
//     }

//     root.addEventListener('click', function (e) {
//       var card = e.target.closest('[data-bundle-card]');
//       if (!card || !root.contains(card)) return;
//       toggleVariant(card.dataset.variantId, card);
//     });

//     var firstCard = getAllCards()[0];
//     if (firstCard) {
//       selectedIds = [firstCard.dataset.variantId];
//     }
//     updateAllVisuals();
//     updateDisabledState();
//     updateBar();

//     addBtn.addEventListener('click', function () {
//       if (selectedIds.length !== maxSelect || addBtn.disabled) return;

//       addBtn.disabled = true;
//       var originalLabel = addBtn.textContent;
//       addBtn.textContent = 'Adding…';

//       var bundleId = 'bundle-' + Date.now();
//       var items = [];

//       if (mainVariantId) {
//         items.push({
//           id: parseInt(mainVariantId, 10),
//           quantity: 1
//         });
//       }

//       selectedIds.forEach(function (variantId) {
//         var refCard = cardsForVariant(variantId)[0];
//         if (!refCard) return;

//         var accOriginal   = parseInt(refCard.dataset.price, 10);
//         var discountAmt   = Math.round((accOriginal * discountPct) / 100);
//         var accDiscounted = accOriginal - discountAmt;

//         items.push({
//           id: parseInt(variantId, 10),
//           quantity: 1,
//           properties: {
//             _bundled_item:           'true',
//             _bundle_id:              bundleId,
//             _original_price:         (accOriginal   / 100).toFixed(2),
//             _discounted_price:       (accDiscounted / 100).toFixed(2),
//             _bundle_discount_amount: (discountAmt   / 100).toFixed(2)
//           }
//         });
//       });

//       fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
//         ? window.Shopify.routes.root + 'cart/add.js'
//         : '/cart/add.js', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
//         body: JSON.stringify({ items: items })
//       })
//         .then(function (res) {
//           if (!res.ok) throw new Error('Cart add failed');
//           return res.json();
//         })
//         .then(function () {
//           selectedIds = [];
//           updateAllVisuals();
//           updateDisabledState();
//           updateBar();
//           addBtn.textContent = originalLabel;

//           document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

//           window.setTimeout(function () {
//             openPrestigeCartDrawer();
//           }, 50);
//         })
//         .catch(function (err) {
//           console.error('Complete Your Bundle — add to cart error:', err);
//           addBtn.textContent = originalLabel;
//           addBtn.disabled = selectedIds.length !== maxSelect;
//           alert('Something went wrong, please try again.');
//         });
//     });
//   });
// })();